export default __webpack_public_path__ + "static/media/dribbble-icon.af8daba6.svg";